import React from 'react';
import { getSubtypesForType } from '@/config/celebrationRegistry';

interface SubtypePickerProps {
  celebrationType: string;
  selectedSubtype: string | null;
  onSelect: (subtypeKey: string | null) => void;
}

export const SubtypePicker: React.FC<SubtypePickerProps> = ({
  celebrationType,
  selectedSubtype,
  onSelect,
}) => {
  const subtypes = getSubtypesForType(celebrationType);

  if (subtypes.length === 0) return null;

  return (
    <div className="space-y-3">
      <h3 className="text-xs font-semibold text-muted-foreground uppercase tracking-wider">
        Narrow it down (optional)
      </h3>
      <div className="flex flex-wrap gap-2">
        {/* Skip / None option */}
        <button
          type="button"
          onClick={() => onSelect(null)}
          className={`
            px-4 py-2 rounded-full text-sm font-medium border transition-all duration-150
            ${selectedSubtype === null
              ? 'bg-primary text-primary-foreground border-primary shadow-sm'
              : 'bg-background text-muted-foreground border-input hover:border-primary/40 hover:text-foreground'
            }
          `}
        >
          None / Custom
        </button>
        {subtypes.map((st) => {
          const isSelected = selectedSubtype === st.key;
          return (
            <button
              key={st.key}
              type="button"
              onClick={() => onSelect(st.key)}
              className={`
                px-4 py-2 rounded-full text-sm font-medium border transition-all duration-150
                ${isSelected
                  ? 'bg-primary text-primary-foreground border-primary shadow-sm'
                  : 'bg-background text-foreground border-input hover:border-primary/40 hover:bg-muted/50'
                }
              `}
            >
              {st.label}
            </button>
          );
        })}
      </div>
    </div>
  );
};
